import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white fixed w-full h-16 z-10" }
const _hoisted_2 = { class: "relative flex justify-center items-center w-full h-16" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.header_option)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.entryPageLinkTo,
            class: "cursor-pointer h-16 w-2/3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.header_option.logo_url,
                alt: "logo",
                class: "object-contain h-16 m-auto"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: _ctx.mypageLinkTo,
            class: "absolute cursor-pointer right-0 h-full flex flex-col mr-2 text-primary-main"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                viewBox: "0 0 17 22",
                class: "fill-current h-6 m-auto",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M13.2 5.0002C13.2 7.6474 11.0472 9.8002 8.4 9.8002C5.7528 9.8002 3.6 7.6474 3.6 5.0002C3.6 2.353 5.7528 0.200195 8.4 0.200195C11.0472 0.200195 13.2 2.353 13.2 5.0002ZM16.8 20.6002C16.8 21.2626 16.2636 21.8002 15.6 21.8002H1.2C0.5364 21.8002 0 21.2626 0 20.6002C0 15.9682 3.7692 12.2002 8.4 12.2002C13.0308 12.2002 16.8 15.9682 16.8 20.6002Z"
                })
              ], -1),
              _createElementVNode("span", { class: "text-xs" }, "マイページ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}